import FormInput from '../templates/FormInput';
import { FormItemProps } from '../templates/FormProps';
import { MESSAGE } from '@vindr/services/constants/message.constant';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

const Username = ({
  name = 'username',
  label = 'Username',
  placeholder = 'Enter username',
  rules,
  required = true,
  disabled,
  ...props
}: FormItemProps): JSX.Element => {
  const { t } = useTranslation('Vindoc');

  const rulesMemo = useMemo(() => {
    const rulesState: any = [
      {
        validator: async (rule, value) => {
          if (!value) return Promise.resolve();
          const [MIN_LENGTH, MAX_LENGTH] = [4, 50];

          if (value.length < MIN_LENGTH) {
            return Promise.reject(t('Username must be at least 4 characters'));
          }

          if (value.length > MAX_LENGTH) {
            return Promise.reject(t('Username must be less than 50 characters'));
          }

          // const InvalidRegex = /^(?=.{4,50}$)(?![_.@])(?!.*[_.@]{2})[a-z0-9_.@]+[a-z0-9]+$/;
          const InvalidRegex = [
            new RegExp(`^(?=.{${MIN_LENGTH},${MAX_LENGTH}}$)`), // Check length
            /^(?!.*[_.@]{2})/, // Check for consecutive special characters
            /^(?!.*[_.@]$)/, // Check for special characters at the end
            /^[a-z0-9_.@]+[a-z0-9]+$/, // Check for special characters at the beginning
          ];

          return InvalidRegex.every((regex) => regex.test(value))
            ? Promise.resolve()
            : Promise.reject(t('Invalid username'));
        },
      },
    ];

    if (required) rulesState.push({ required: true, message: t(MESSAGE.INLINE.IEM_0001) });
    if (rules) rulesState.push(...rules);

    return rulesState;
  }, [t, rules, required]);

  return <FormInput rules={rulesMemo} {...{ name, label, placeholder, disabled, ...props }} />;
};

export default Username;
